import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	contactInfo: {
		boxSizing: 'border-box',
		padding: '20px 10px 10px 0',
		position: 'relative',
	},
});
